import { styled, css } from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled(motion.div)<{ $appearance?: 'inline' | 'floating' }>`
  ${({ theme: { colors, spacings }, $appearance = 'inline' }) => css`
    align-items: center;
    background: ${colors.brandLight};
    box-sizing: border-box;
    display: flex;
    gap: ${spacings.s8};
    padding: ${spacings.s8} ${spacings.s24};
    width: 100%;

    .ds-checkbox {
      align-items: center;
    }

    ${
      $appearance === 'floating' &&
      css`
        backdrop-filter: blur(1rem);
        background: ${colors.brandDarkAlpha60};
        border-radius: 999px;
        bottom: ${spacings.s24};
        box-shadow:
          0px 0.25rem 0.25rem 0px ${colors.brandDarkAlpha30},
          0px 0px 0px 1px ${colors.brandDarkAlpha10},
          0px 0.75rem 0.5rem -0.25rem ${colors.brandDarkAlpha15},
          0px 1px 1px 0px ${colors.brandDarkAlpha20};
        left: 50%;
        padding: ${spacings.s8} ${spacings.s16};
        position: fixed;
        transform: translateX(-50%);
        width: max-content;
        z-index: 1000;
      `
    }
  `}
`;

// Matches the select-all checkbox's own footprint (its "Check" square is 2em at the default
// 'md' size, i.e. 2rem) so swapping between it and the loading spinner doesn't shift the bar.
export const SpinnerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 2rem;
  justify-content: center;
  width: 2rem;
`;
